import AchievementsRecent from "./AchievementsRecent";

export default AchievementsRecent;
